import axios from "axios";
import { ADMIN_AUTH_KEY } from "../utils/constants.js";
import { showError } from "../utils/toastUtils.js";

if (!process.env.REACT_APP_API_URL) {
  console.error(
    "API URL missing. Please set REACT_APP_API_URL in your .env file.",
  );
}
const tokenErrors = ["TOKEN_EXPIRED", "NOT_AUTHORIZED", "INVALID_TOKEN"];

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 120000,
});

api.interceptors.request.use(
  (config) => {
    const stored = localStorage.getItem(ADMIN_AUTH_KEY);

    if (stored) {
      const parsed = JSON.parse(stored);
      const token = parsed?.token;

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const statusCode = error.response?.status;
    const status = error.response?.data?.status;
    const message = error.response?.data?.message ?? "";

    if (
      statusCode === 401 &&
      status === "fail" &&
      tokenErrors.some((err) => message.includes(err))
    ) {
      showError("Session Expired ! Please Login Again");
      console.warn("Token expired. Logging out...");

      localStorage.removeItem(ADMIN_AUTH_KEY);
    }

    return Promise.reject(error);
  },
);

export default api;
